<template>
  <div class="animated fadeIn">
    <div class="text-center mb-3">
      <b-button-group>
        <b-button
          :variant="page == 'shop' ? 'primary' : ''"
          @click="page = 'shop'"
          >{{ $t("Shop") }}</b-button
        >
        <b-button
          :variant="page == 'limits' ? 'primary' : ''"
          @click="page = 'limits'"
          >{{ $t("Limits") }}</b-button
        >
        <b-button
          :variant="page == 'terminals' ? 'primary' : ''"
          @click="page = 'terminals'"
          >{{ $t("Terminals") }}</b-button
        >
        <b-button
          :variant="page == 'users' ? 'primary' : ''"
          @click="page = 'users'"
          >{{ $t("Users") }}</b-button
        >
      </b-button-group>
    </div>
    <b-row>
      <b-col cols="12" xl="6" v-if="page == 'shop'">
        <b-card style="position: relative">
          <b-form
            @submit.prevent="onSubmitDetails"
            autocomplete="off"
            ref="cnt"
          >
            <div class="mb-2 position-relative">
              <div class="multiselect-lbl" v-if="details.tenant_id">
                {{ $t("Tenant") }}
              </div>
              <multiselect
                v-model="details.tenant_id"
                :options="tenantsList"
                placeholder="Select tenant"
                track-by="brand_name"
                label="brand_name"
                :translate="false"
              ></multiselect>
            </div>

            <FloatingLabel v-model="details.code" label="Code" size="sm" />
            <FloatingLabel
              v-model="details.core_location_id"
              label="Location ID"
              size="sm"
            />
            <FloatingLabel v-model="details.name" label="Name" size="sm" />
            <FloatingLabel
              v-model="details.address"
              label="Address"
              type="textarea"
              size="sm"
            />
            <FloatingLabel v-model="details.city" label="City" size="sm" />
            <FloatingLabel v-model="details.county" label="County" size="sm" />
            <FloatingLabel
              v-model="details.country"
              label="Country"
              size="sm"
            />

            <div class="mb-2 position-relative">
              <div class="multiselect-lbl text-muted">
                {{ $t("Shop Groups") }}
              </div>
              <multiselect
                v-model="egroup_id"
                :options="groupList"
                placeholder="No group"
                :multiple="true"
                track-by="eid"
                label="name"
                :disabled="true"
                :translate="false"
              ></multiselect>
            </div>

            <!--div class="mb-2 position-relative">
              <div class="multiselect-lbl" v-if="details.company_id">{{$t('Companies')}}</div>
              <multiselect
                v-model="details.company_id"
                :options="companyList"
                placeholder="Select a company"
                track-by="eid"
                label="name"
                :translate="false"
              ></multiselect>
            </div-->

            <div class="mb-2 position-relative">
              <div class="multiselect-lbl" v-if="details.status">
                {{ $t("Status") }}
              </div>
              <multiselect
                v-model="details.status"
                :options="statusList"
                placeholder="Select a status"
              ></multiselect>
            </div>

            <b-form-group
              :label="$t('Test')"
              class="grouping py-2 px-3 mb-3 mt-0"
            >
              <b-form-checkbox
                v-model="details.test"
                :value="true"
                :unchecked-value="false"
                >{{ $t("Enable test mode") }}</b-form-checkbox
              >
            </b-form-group>

            <FloatingLabel
              v-model="details.tills_number"
              label="Tills Number"
              size="sm"
            />
            <FloatingLabel
              v-model="details.sbt_number"
              label="Self Betting Terminals Number"
              size="sm"
            />

            <b-form-group
              :label="$t('Allow Print Duplicate')"
              class="grouping py-2 px-3 mb-3 mt-0"
            >
              <b-form-checkbox
                v-model="details.allow_print_duplicate"
                :value="true"
                :unchecked-value="false"
                >{{ $t("Enable print duplicate") }}</b-form-checkbox
              >
            </b-form-group>

            <div class="mb-2 position-relative">
              <div class="multiselect-lbl" v-if="details.firewall_ruleset_id">
                {{ $t("Firewall Ruleset") }}
              </div>
              <multiselect
                v-model="details.firewall_ruleset_id"
                :options="firewallRulesetList"
                placeholder="Select shop ruleset"
                track-by="eid"
                label="name"
                :translate="false"
              ></multiselect>
            </div>

            <div class="mb-2 position-relative">
              <div class="multiselect-lbl" v-if="details.firewall_group_id">
                {{ $t("Firewall Group") }}
              </div>
              <multiselect
                v-model="details.firewall_group_id"
                :options="firewallGroupRulesetList"
                placeholder="Select shop group ruleset"
                track-by="eid"
                label="name"
                :translate="false"
              ></multiselect>
            </div>

            <div class="mb-2 position-relative">
              <div class="multiselect-lbl" v-if="allowed_products">
                {{ $t("Allowed Products") }}
              </div>
              <multiselect
                v-model="allowed_products"
                :options="productsList"
                placeholder="Select products"
                track-by="eid"
                label="name"
                :translate="false"
                :multiple="true"
              ></multiselect>
            </div>

            <b-form-group
              :label="$t('Online')"
              class="grouping py-2 px-3 mb-3 mt-0"
            >
              <b-form-checkbox
                v-model="details.online"
                :value="true"
                :unchecked-value="false"
                >{{ $t("Enable Online") }}</b-form-checkbox
              >
            </b-form-group>

            <div style="text-align: right">
              <b-button type="submit" variant="success">{{
                $t("Save")
              }}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col cols="12" xl="8" v-if="eid && eid != '0' && page == 'limits'">
        <b-card style="position: relative">
          <b-form @submit.prevent="onSubmitLimits" autocomplete="off" ref="lim">
            <FloatingLabel
              v-model="limits.min_total_bet"
              label="Min Total Bet"
              size="sm"
            />
            <FloatingLabel
              v-model="limits.max_total_bet"
              label="Max Total Bet"
              size="sm"
            />

            <b-form-group
              :label="$t('Income limits warning')"
              class="grouping p-3 mb-3 mt-0"
              :description="
                $t(
                  'Pairs of (T total_amount, X minutes) where a warning will be sent if the total cached in amount in X is greater than T'
                )
              "
            >
              <LimitsListEditor
                :items="limits.warning"
                :addLabel="$t('Add warning')"
                :deleteTootltip="$t('Delete')"
                placeholderAmount="total amount"
                placeholderMinutes="minutes"
                size="sm"
              />
            </b-form-group>

            <b-form-group
              :label="$t('Income limits block')"
              class="grouping p-3 mb-3 mt-0"
              :description="
                $t(
                  'Pairs of (T total_amount, X minutes) where the shop will be blocked and a warning will be sent if the total cached in amount in X is greater than T'
                )
              "
            >
              <LimitsListEditor
                :items="limits.block"
                :addLabel="$t('Add block')"
                :deleteTootltip="$t('Delete')"
                placeholderAmount="total amount"
                placeholderMinutes="minutes"
                size="sm"
              />
            </b-form-group>

            <b-form-group
              :label="$t('Shop balance limits')"
              class="grouping p-3 mb-3 mt-0"
              :description="
                $t(
                  'A warning will be sent and/or the shop will be blocked if the limits are reached'
                )
              "
            >
              <b-row>
                <b-col cols="12" md="4">
                  <FloatingLabel
                    v-model.number="limits.balance_warning_amount"
                    label="Warning Amount"
                    size="sm"
                  />
                </b-col>
                <b-col cols="12" md="4">
                  <FloatingLabel
                    v-model.number="limits.balance_block_amount"
                    label="Block Amount"
                    size="sm"
                  />
                </b-col>
                <b-col cols="12" md="4">
                  <FloatingLabel
                    v-model.number="limits.balance_period"
                    label="Minutes"
                    size="sm"
                  />
                </b-col>
              </b-row>
            </b-form-group>

            <b-form-group
              :label="$t('Alert Email Addresses')"
              :description="$t('Email recipients for warning/block alerts')"
              class="grouping p-3 mb-3 mt-0"
            >
              <ListEditor
                :items="limits.alert_email_addresses"
                :addLabel="$t('Add new email address')"
                :deleteTootltip="$t('Delete')"
                size="sm"
              />
            </b-form-group>

            <b-form-row>
              <b-col cols="4">
                <FloatingLabel
                  v-model="limits.onlineCashMaxNumberDepositsPerPlayer.value"
                  label="Max Number Of Deposits Per Player"
                  size="sm"
                />
              </b-col>
              <b-col cols="5">
                <FloatingLabel
                  v-model="limits.onlineCashMaxNumberDepositsPerPlayer.interval"
                  label="Per Time Interval"
                  size="sm"
                  description="Valid time units are  's', 'm', 'h', 'd' (eg. 1d2h45m10s)"
                />
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Block Shop')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="
                      limits.onlineCashMaxNumberDepositsPerPlayer.block_shop
                    "
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Block Shop") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Alert')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="limits.onlineCashMaxNumberDepositsPerPlayer.alert"
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Alert") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="4">
                <FloatingLabel
                  v-model="limits.onlineCashMaxTotalSumDepositsPerShop.value"
                  label="Max Total Sum Deposits Per Shop"
                  size="sm"
                />
              </b-col>
              <b-col cols="5">
                <FloatingLabel
                  v-model="limits.onlineCashMaxTotalSumDepositsPerShop.interval"
                  label="Per Time Interval"
                  size="sm"
                  description="Valid time units are  's', 'm', 'h', 'd' (eg. 1d2h45m10s)"
                />
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Block Shop')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="
                      limits.onlineCashMaxTotalSumDepositsPerShop.block_shop
                    "
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Block Shop") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Alert')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="limits.onlineCashMaxTotalSumDepositsPerShop.alert"
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Alert") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="9">
                <FloatingLabel
                  v-model="limits.onlineCashMaxSingleDeposit.value"
                  label="Max Single Deposit"
                  size="sm"
                />
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Block Shop')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="limits.onlineCashMaxSingleDeposit.block_shop"
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Block Shop") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Alert')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="limits.onlineCashMaxSingleDeposit.alert"
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Alert") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="4">
                <FloatingLabel
                  v-model="limits.onlineCashMaxTotalSumDepositsPerPlayer.value"
                  label="Max Total Sum Deposits Per Player"
                  size="sm"
                />
              </b-col>
              <b-col cols="5">
                <FloatingLabel
                  v-model="
                    limits.onlineCashMaxTotalSumDepositsPerPlayer.interval
                  "
                  label="Per Time Interval"
                  size="sm"
                  description="Valid time units are  's', 'm', 'h', 'd' (eg. 1d2h45m10s)"
                />
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Block Shop')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="
                      limits.onlineCashMaxTotalSumDepositsPerPlayer.block_shop
                    "
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Block Shop") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Alert')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="
                      limits.onlineCashMaxTotalSumDepositsPerPlayer.alert
                    "
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Alert") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col>
                <b-form-group
                  :label="$t('Reset to Global')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="limits.reset_to_global"
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Reset") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <div style="text-align: right">
              <b-button type="submit" variant="success">{{
                $t("Save")
              }}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="eid && eid != '0' && page == 'terminals'">
      <b-col cols="12">
        <b-card style="position: relative">
          <terminals
            :eshop_id="eid"
            :etenant_id="
              details.tenant_id && details.tenant_id.eid
                ? details.tenant_id.eid
                : ''
            "
            :shop_name="details.name"
          />
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="eid && eid != '0' && page == 'users'">
      <b-col cols="12">
        <b-card style="position: relative">
          <users :eshop_id="eid" :shop_name="details.name" />
        </b-card>
      </b-col>
    </b-row>
    <!--b-row v-if="eid && eid != '0'">
      <b-col cols="12">
        <b-card :header="$t('Balance')" style="position:relative">
          <sold-entries
            :eshop_id="eid"
            :etenant_id="details.tenant_id && details.tenant_id.eid ? details.tenant_id.eid : ''"
            :shop_name="details.name"
          />
        </b-card>
      </b-col>
    </b-row-->
  </div>
</template>

<script>
import Multiselect from "@/components/multiselect-filters";
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";
import LimitsListEditor from "@/components/LimitsListEditor";
import ListEditor from "@/components/ListEditor";
import Terminals from "./component/Terminals";
import Users from "./component/Users";
// import SoldEntries from "./component/SoldEntries";
import { evbus, EVENTS } from "@/shared/evbus";

export default {
  name: "shop",
  props: ["selectedeid"],
  components: {
    Multiselect,
    FloatingLabel,
    Terminals,
    LimitsListEditor,
    ListEditor,
    Users,
    // SoldEntries
  },
  data: function () {
    return {
      page: "shop",
      eid: "",
      details: {
        tenant_id: null,
        code: "",
        core_location_id: "",
        name: "",
        address: "",
        city: "",
        county: "",
        country: "",
        status: "",
        test: false,
        tills_number: null,
        sbt_number: null,
        allow_print_duplicate: false,
        firewall_ruleset_id: null,
        firewall_group_id: null,
        eallowed_products_ids: null,
        online: false,
      },

      limits: {
        eid: null, //	bigint	To which shop are the limits applied
        min_total_bet: null, //	bigint	Minumum allowed bet
        max_total_bet: null, //	bigint	Maximum allowed bet
        warning: [], //	bigint[] NULL	Pairs of (T total_amount, X minutes) where a warning will be sent if the total cached in amount in X is greater than T
        block: [], //	bigint[] NULL	Pairs of (T total_amount, X minutes) where the shop will be blocked and a warning will be sent if the total cached in amount in X is greater than T
        alert_email_addresses: [], // text[] NULL	Email recipients for warning/block alerts,
        balance_warning_amount: null,
        balance_block_amount: null,
        balance_period: null,

        onlineCashMaxNumberDepositsPerPlayer: {
          value: "",
          interval: "",
          block_shop: false,
          alert: false,
        }, // "x;y;bool;bool"
        onlineCashMaxTotalSumDepositsPerShop: {
          value: "",
          interval: "",
          block_shop: false,
          alert: false,
        }, // "x;bool;bool"
        onlineCashMaxSingleDeposit: {
          value: "",
          block_shop: false,
          alert: false,
        }, // "x;bool;bool"
        onlineCashMaxTotalSumDepositsPerPlayer: {
          value: "",
          interval: "",
          block_shop: false,
          alert: false,
        }, // "x;y;bool;bool"
        reset_to_global: false,
      },

      statusList: ["active", "inactive", "blocked"],
      newId: false,
      temp: {},
      allowed_products: [],
      egroup_id: null,
      company_id: null,
    };
  },
  computed: {
    tenantsList() {
      return this.$store.getters["cache/tenants"];
    },
    groupList() {
      return this.$store.getters["cache/shopGroups"];
    },
    companyList() {
      const self = this;
      const list = this.$store.getters["cache/companies"];

      const tmp = [];
      if (this.details.tenant_id && this.details.tenant_id.eid) {
        list.forEach((item) => {
          if (item.etenant_id == self.details.tenant_id.eid) {
            const data = JSON.parse(JSON.stringify(item));
            tmp.push(data);
          }
        });
      }
      return tmp;
    },
    firewallRulesetList() {
      return this.$store.getters["cache/firewalls"];
    },
    firewallGroupRulesetList() {
      const firewallByID = this.$store.getters["cache/firewallByID"];
      const shopGroups = this.$store.getters["cache/shopGroups"];
      const tmp = [];
      shopGroups.forEach((item) => {
        if (item && item.eshop_ids && item.eshop_ids.length) {
          if (item.eshop_ids.indexOf(this.eid) > -1) {
            const efirewall_ruleset_id = item.efirewall_ruleset_id;
            if (efirewall_ruleset_id) {
              const data = firewallByID(efirewall_ruleset_id);
              if (data) {
                let firewall = JSON.parse(JSON.stringify(data));
                firewall.name = `${item.name} - ${firewall.name}`;
                firewall.eid = item.eid; // we need to save the shop group id not the filerewall one
                tmp.push(firewall);
              }
            }
          }
        }
      });
      return tmp;
    },
    productsList() {
      return this.$store.getters["cache/products"];
    },
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    Promise.all([
      this.$store.dispatch("cache/fetch", "shopGroups").catch((e) => e),
      this.$store.dispatch("cache/fetch", "firewalls").catch((e) => e),
      this.$store.dispatch("cache/fetch", "companies").catch((e) => e),
      this.$store.dispatch("cache/fetch", "tenants").catch((e) => e),
    ]).finally(() => {
      if (this.eid != "0" && this.eid != "") {
        this.loadData();
      } else {
        this.newId = true;
      }
    });
  },
  methods: {
    loadData() {
      if (this.eid == "") return;

      const loader = this.$loading.open({
        container: this.$refs.cnt,
      });

      const loaderl = this.$loading.open({
        container: this.$refs.lim,
      });

      Promise.all([
        this.$store.dispatch("cache/fetch", "shopGroups").catch((e) => e),
        this.$store.dispatch("cache/fetch", "firewalls").catch((e) => e),
        this.$store.dispatch("cache/fetch", "companies").catch((e) => e),
        this.$store.dispatch("cache/fetch", "tenants").catch((e) => e),
        this.$store.dispatch("cache/fetch", "products").catch((e) => e),
      ])
        .catch((err) => {})
        .finally(() => {
          this.$store
            .dispatch("shop/read", this.eid)
            .then((resp) => {
              this.temp = resp.data;

              const shopGroups = this.$store.getters["cache/shopGroups"];
              const tmp = [];
              shopGroups.forEach((item) => {
                if (item && item.eshop_ids && item.eshop_ids.length) {
                  if (item.eshop_ids.indexOf(resp.data.eid) > -1) {
                    tmp.push({ name: item.name });
                  }
                }
              });
              this.egroup_id = tmp;

              this.populateData(resp.data);
            })
            .catch((err) => {
              this.showErrorNotification(err);
            })
            .finally(() => {
              loader.close();
            });
        });

      this.$store
        .dispatch("shop/readShopLimit", this.eid)
        .then((resp) => {
          const l = resp.data;
          this.limits.eid = l.eid;
          this.limits.min_total_bet = l.min_total_bet;
          this.limits.max_total_bet = l.max_total_bet;

          this.limits.balance_warning_amount = l.balance_warning_amount;
          this.limits.balance_block_amount = l.balance_block_amount;
          this.limits.balance_period = l.balance_period;

          let tmp = [];
          if (l.warning && l.warning.length) {
            for (let i = 0; i < l.warning.length; i += 2)
              tmp.push([l.warning[i], l.warning[i + 1]]);
          }
          this.limits.warning = tmp;

          tmp = [];
          if (l.block && l.block.length) {
            for (let i = 0; i < l.block.length; i += 2)
              tmp.push([l.block[i], l.block[i + 1]]);
          }
          this.limits.block = tmp;

          if (l.alert_email_addresses && l.alert_email_addresses.length) {
            this.limits.alert_email_addresses = l.alert_email_addresses;
          }

          let online_cash_limits = {};
          try {
            online_cash_limits = JSON.parse(l.online_cash_limits);
          } catch (err) {
            /* noop*/
          }

          if (online_cash_limits.onlineCashMaxNumberDepositsPerPlayer) {
            const parts =
              online_cash_limits.onlineCashMaxNumberDepositsPerPlayer.split(
                ";",
                4
              );
            if (parts.length === 4) {
              this.limits.onlineCashMaxNumberDepositsPerPlayer = {
                value: parts[0] ? parts[0] : "",
                interval: parts[1] ? parts[1] : "",
                block_shop: parts[2] && parts[2] === "true" ? true : false,
                alert: parts[3] && parts[3] === "true" ? true : false,
              };
            }
          }
          if (online_cash_limits.onlineCashMaxTotalSumDepositsPerShop) {
            const parts =
              online_cash_limits.onlineCashMaxTotalSumDepositsPerShop.split(
                ";",
                4
              );
            if (parts.length === 4) {
              this.limits.onlineCashMaxTotalSumDepositsPerShop = {
                value: parts[0] ? parts[0] : "",
                interval: parts[1] ? parts[1] : "",
                block_shop: parts[2] && parts[2] === "true" ? true : false,
                alert: parts[3] && parts[3] === "true" ? true : false,
              };
            }
          }
          if (online_cash_limits.onlineCashMaxTotalSumDepositsPerPlayer) {
            const parts =
              online_cash_limits.onlineCashMaxTotalSumDepositsPerPlayer.split(
                ";",
                4
              );
            if (parts.length === 4) {
              this.limits.onlineCashMaxTotalSumDepositsPerPlayer = {
                value: parts[0] ? parts[0] : "",
                interval: parts[1] ? parts[1] : "",
                block_shop: parts[2] && parts[2] === "true" ? true : false,
                alert: parts[3] && parts[3] === "true" ? true : false,
              };
            }
          }
          if (online_cash_limits.onlineCashMaxSingleDeposit) {
            const parts = online_cash_limits.onlineCashMaxSingleDeposit.split(
              ";",
              3
            );
            if (parts.length === 3) {
              this.limits.onlineCashMaxSingleDeposit = {
                value: parts[0] ? parts[0] : "",
                block_shop: parts[1] && parts[1] === "true" ? true : false,
                alert: parts[2] && parts[2] === "true" ? true : false,
              };
            }
          }

          this.limits.reset_to_global = online_cash_limits.reset_to_global
            ? true
            : false;
        })
        .catch((err) => {})
        .finally(() => {
          loaderl.close();
        });
    },
    onSubmitLimits() {
      const loader = this.$loading.open({
        container: this.$refs.lim,
      });

      const limitsData = JSON.parse(JSON.stringify(this.limits));
      limitsData.eshop_id = this.eid;

      limitsData.min_total_bet = parseFloat(limitsData.min_total_bet);
      limitsData.max_total_bet = parseFloat(limitsData.max_total_bet);

      limitsData.balance_warning_amount = parseFloat(
        limitsData.balance_warning_amount
      );
      limitsData.balance_block_amount = parseFloat(
        limitsData.balance_block_amount
      );
      limitsData.balance_period = parseFloat(limitsData.balance_period);

      let tmp = [];
      if (limitsData.warning && limitsData.warning.length) {
        limitsData.warning.forEach((item) => {
          tmp.push(parseFloat(item[0]));
          tmp.push(parseFloat(item[1]));
        });
      }
      limitsData.warning = tmp;

      tmp = [];
      if (limitsData.block && limitsData.block.length) {
        limitsData.block.forEach((item) => {
          tmp.push(parseFloat(item[0]));
          tmp.push(parseFloat(item[1]));
        });
      }
      limitsData.block = tmp;

      const onlineCashLimits = {};
      let key = "onlineCashMaxNumberDepositsPerPlayer";
      onlineCashLimits[key] = this.fourValuesToString(limitsData[key]);
      delete limitsData[key];

      key = "onlineCashMaxTotalSumDepositsPerShop";
      onlineCashLimits[key] = this.fourValuesToString(limitsData[key]);
      delete limitsData[key];

      key = "onlineCashMaxSingleDeposit";
      onlineCashLimits[key] = this.threeValuesToString(limitsData[key]);
      delete limitsData[key];

      key = "onlineCashMaxTotalSumDepositsPerPlayer";
      onlineCashLimits[key] = this.fourValuesToString(limitsData[key]);
      delete limitsData[key];

      onlineCashLimits.reset_to_global = limitsData.reset_to_global
        ? true
        : false;

      limitsData.online_cash_limits = JSON.stringify(onlineCashLimits);

      this.$store
        .dispatch("shop/createShopLimit", limitsData)
        .then((resp) => {
          let msg = "Shop limits updated";
          this.showSuccessNotification(msg);
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    fourValuesToString(data) {
      return `${typeof data.value !== "undefined" ? data.value : ""};${
        typeof data.interval !== "undefined" ? data.interval : ""
      };${data.block_shop ? "true" : "false"};${data.alert ? "true" : "false"}`;
    },
    threeValuesToString(data) {
      return `${typeof data.value !== "undefined" ? data.value : ""};${
        data.block_shop ? "true" : "false"
      };${data.alert ? "true" : "false"}`;
    },
    onSubmitDetails() {
      const loader = this.$loading.open({
        container: this.$refs.cnt,
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "shop/update";
      if (this.newId) {
        apiAction = "shop/create";
      } else {
        detailsData.eid = this.eid;
      }

      if (detailsData.tenant_id) {
        detailsData.etenant_id = detailsData.tenant_id.eid;
        delete detailsData.tenant_id;
      }

      if (detailsData.ecompany_id) {
        delete detailsData.ecompany_id;
      }
      // if (detailsData.company_id) {
      //   detailsData.ecompany_id = detailsData.company_id.eid;
      //   delete detailsData.company_id;
      // } else {
      //   detailsData.ecompany_id = "";
      // }

      if (detailsData.firewall_ruleset_id) {
        detailsData.efirewall_ruleset_id = detailsData.firewall_ruleset_id.eid;
        delete detailsData.firewall_ruleset_id;
      }

      if (detailsData.firewall_group_id) {
        detailsData.efirewall_group_id = detailsData.firewall_group_id.eid;
        delete detailsData.firewall_group_id;
      }

      if (detailsData.tills_number) {
        detailsData.tills_number = parseInt(detailsData.tills_number);
      }

      if (detailsData.sbt_number) {
        detailsData.sbt_number = parseInt(detailsData.sbt_number);
      }
      if (this.allowed_products) {
        let allowedProductsIDs = [];
        this.allowed_products.forEach(({ eid }) => {
          allowedProductsIDs.push(eid);
        });
        detailsData.eallowed_products_ids = allowedProductsIDs;
      }

      // console.log(detailsData.eallowed_products_ids);

      this.$store
        .dispatch(apiAction, detailsData)
        .then((resp) => {
          let msg = "Shop updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            this.eid = resp.data.id;
            this.loadData();
            msg = "Shop created";
          }
          this.showSuccessNotification(msg);
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.tenant_id = r.etenant_id;
      this.details.code = r.code;
      this.details.core_location_id = r.core_location_id;
      this.details.name = r.name;
      this.details.address = r.address;
      this.details.city = r.city;
      this.details.county = r.county;
      this.details.phone_number = r.phone_number;
      this.details.egroup_id = r.egroup_id;
      this.details.country = r.country;
      this.details.status = r.status;
      this.details.test = r.test;
      this.details.tills_number = r.tills_number;
      this.details.sbt_number = r.sbt_number;
      this.details.allow_print_duplicate = r.allow_print_duplicate;
      this.details.firewall_ruleset_id = r.efirewall_ruleset_id;
      this.details.firewall_group_id = r.efirewall_group_id;
      this.details.online = r.online;
      // this.details.company_id = r.ecompany_id;

      if (r.eallowed_products_ids) {
        const productByID = this.$store.getters["cache/productByID"];
        let allowedProductsIDs = [];
        r.eallowed_products_ids.forEach((productId) => {
          allowedProductsIDs.push({
            eid: productId,
            name: productByID(productId).name,
          });
        });
        this.allowed_products = allowedProductsIDs;
      }

      if (this.details.tenant_id) {
        this.tenantsList.forEach((element) => {
          if (element.eid == this.details.tenant_id) {
            this.details.tenant_id = element;
            return;
          }
        });
      }

      // if (this.details.egroup_id) {
      // console.log("this.details.egroup_id", this.details.egroup_id);
      // this.groupList.forEach(element => {
      //   if (element.eid == this.details.group_id) {
      //     this.details.group_id = element;
      //     return;
      //   }
      // });
      // }

      if (this.details.firewall_ruleset_id) {
        this.firewallRulesetList.forEach((element) => {
          if (element.eid == this.details.firewall_ruleset_id) {
            this.details.firewall_ruleset_id = element;
            return;
          }
        });
      }

      if (this.details.firewall_group_id) {
        this.firewallGroupRulesetList.forEach((element) => {
          if (element.eid == this.details.firewall_group_id) {
            this.details.firewall_group_id = element;
            return;
          }
        });
      }

      // if (this.details.company_id) {
      //   const cid = this.details.company_id;
      //   this.details.company_id = null;
      //   this.companyList.forEach(element => {
      //     if (element.eid == cid) {
      //       this.details.company_id = element;
      //       return;
      //     }
      //   });
      // }
    },
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Shop", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
  },
};
</script>

<style lang="scss" scoped></style>
